// extracted by mini-css-extract-plugin
export var Article = "Article-module--Article--e6567";